export function formatDate(dateString?: string): string {
    if (!dateString) return 'N/A';
    return dateString.split('-').reverse().join('-');
  }

/**
 * Formats market value in millions of euros
 * @param amount - The amount in euros
 * @returns Formatted string like "25 M" for 25 million, "0.16 M" for 152,800
 */
export function formatMarketValue(amount?: number): string {
  if (!amount || amount === 0) return 'N/A';
  
  const millions = amount / 1000000;
  
  // Format with 2 decimal places for values less than 1M
  if (millions < 1) {
    return `${millions.toFixed(2)} M`;
  }
  
  // Format with 1 decimal place for values 1M or more
  return `${millions.toFixed(1)} M`;
}
  